import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  topNavBar: {
    backgroundColor: theme.palette.background.navbar,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 1200,
  },
  topNavBarItems: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.background.navbar,
    color: theme.palette.primary.main,
    width: '100%',
    margin: 'auto',
    position: 'fixed',
    paddingLeft: 14,
    paddingRight: 8,
  },
  root: {
    marginLeft: 'auto',
    '& > *': {
      margin: theme.spacing(0),
    },
  },
  input: {
    display: 'none',
  },
  user: {
    color: theme.palette.text.disabled,
    padding: '6px 16px',
  },
}));

export default useStyles;
